export enum SelectOperatorType {
  EQUAL = "EQUAL" as any,
  NOT_EQUAL = "NOT_EQUAL" as any,
  IN = "IN" as any,
  NOT_IN = "NOT_IN" as any,
}
